import React from "react";

import { useGetCurrentCompanyApplicationQuery } from "EmployerApplication/api";
import { api, paymentURL, documentsUploadPageURL, reviewEmployeeEmailsURL, nextEmployerApplicationURL } from "EmployerApplication/urls";
import createDecorator from "final-form-focus";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

// Tooltips
import { validateRequired, validateRoutingNumber, composeValidators } from "Utils/Validations";
import { BasicLoading } from "ZeroRuby";

import AgentHeader from "Common/Agent/AgentHeader";
import { SIFinalFormField } from "Common/forms";
import { Row } from "Common/Grid";
import NavigationControls from "Common/NavigationControls";
import { Surface, SurfaceHeader, SurfaceSection } from "Theme/Surface";

const focusOnErrors = createDecorator();

export const AddPaymentInformationForm = () => {
  const history = useHistory();
  const { data: companyApplication, isLoading } = useGetCurrentCompanyApplicationQuery();

  if (isLoading) return <BasicLoading />;

  const { bankName, bankRoutingNumber, bankAccountNumber, hasMecPlan } = companyApplication;

  const initialValues = {
    bankName,
    bankRoutingNumber,
    bankAccountNumber,
  };

  const submitHandler = (values) => {
    AnalyticsTracking.trackEvent("payment_information_save_clicked", {});
    const token = companyToken();
    const queryString = token ? `?company_id_token=${token}` : "";

    const nextUrl = nextEmployerApplicationURL(paymentURL, companyApplication);
    return fetchWithCSRFToken(`${api.savePayment}${queryString}`, {
      method: "POST",
      body: JSON.stringify(values),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.error) {
          console.warn("Unable to save payment information.");
        } else {
          history.push(nextUrl);
        }
      });
  };

  return (
    <Form onSubmit={submitHandler} decorators={[focusOnErrors]} initialValues={initialValues}>
      {({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <SurfaceSection title="Payment Information">
            <Row>
              <SIFinalFormField label="Bank Name" name="bankName" validate={validateRequired} md={6} noBounce errorRight />
            </Row>
            <Row>
              <SIFinalFormField
                label="Routing Number"
                name="bankRoutingNumber"
                validate={composeValidators(validateRequired, validateRoutingNumber)}
                md={6}
                noBounce
                errorRight
              />
            </Row>
            <Row>
              <SIFinalFormField label="Account Number" name="bankAccountNumber" validate={validateRequired} md={6} noBounce errorRight />
            </Row>
          </SurfaceSection>
          <NavigationControls backLink={hasMecPlan ? reviewEmployeeEmailsURL : documentsUploadPageURL} submitting={submitting} />
        </form>
      )}
    </Form>
  );
};

const AddPaymentInformationPage = () => {
  return (
    <Surface>
      <SurfaceHeader>Finalize Application</SurfaceHeader>
      <SurfaceSection>
        <AgentHeader>
          Almost done! Please provide a bank account for the first month's premium payment. Payment is usually debited within 2-10 days of application approval.
          Please note that Insurance Carriers will only charge you if the application is approved.
        </AgentHeader>
      </SurfaceSection>
      <AddPaymentInformationForm />
    </Surface>
  );
};

export default AddPaymentInformationPage;
